import React from 'react';

class CustomViewModalsManager {

    constructor() {}

    editSettings({ viewId /*string*/, viewType /*number*/, onSubmit /*function on add*/}) {

        gd.modal.showV4({
            className: 'modal-edit-view-settings',
            component: require('./edit-view/edit-view.jsx'),
            params: {
                viewId: viewId,
                viewType: viewType,
                onSubmit: () => {
                    gd.modal.hide();
                    onSubmit && onSubmit();
                }
            }
        });
    }

    access(view) {
        gd.modal.showV4({
            className: 'modal-custom-view-access',
            component: require("./access/access"),
            params: {
                view
            }
        });
    }

    // this is old ... to be used in future I guess
    // share({ viewId /*string*/}) {
    //     gd.modal.showV4({
    //         className: 'modal-share-view',
    //         component: require('./custom-view/share-view/share-view.jsx'),
    //         params: {
    //             viewId
    //         }
    //     });
    // }

    export({ onSubmit /*function*/}) {
        const options = [
            { value: 'all', label: 'Export all', description: 'Export all items'},
            { value: 'current', label: 'Export current view', description: 'Export filtered items you see in the current view'},
        ];
        gd.modal.showForm({
            className: 'modal-export-to-csv',
            header: {
                title: 'Export to CSV',
            },
            component: require('../export-to-csv/modal-export-to-csv.jsx'),

            params: {
                options,
                defaultValue: 'all',
                onSubmit: (values) => {
                    gd.modal.hide();
                    onSubmit(values.selectedOption);
                },
            }
        })
    }



}

module.exports = CustomViewModalsManager;